export interface IFormData
{
  dayOffset?: number
  offsetDays?: number
  overrideDays?: number
  isLoading: boolean
  noData?: boolean
}

export class FormData implements IFormData
{
  dayOffset?: number
  offsetDays?: number
  overrideDays?: number
  isLoading: boolean
  noData?: boolean

  constructor() {
    this.dayOffset = 0
    this.offsetDays = 0
    this.overrideDays = 0
    this.isLoading = false
    this.noData = false
  }

}
